import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from 'react-router-dom';
import BodySearch from "../Components/BodySearch";
import Footer from "../Components/Footer";
import Hero from "../Components/Hero";
import { useFetchMultipleTrackingEvents, useFetchTrackingByNumber } from "../hooks/use-queries";
import { useGetUrlParam } from "../hooks/use-url-param";
import LoadingSpinner from "../Components/LoadingSpinner";
import DataNotFound from "../Components/DataNotFound";
import { orderBy } from "lodash";

export default function Home() {
  const navigate = useNavigate()
  const numberParam = useGetUrlParam("transaksi")

  const [trackingIds, setTrackingIds] = useState([])
  const { data: trackingData, isSuccess, isFetching } = useFetchTrackingByNumber(numberParam);

  const results = useFetchMultipleTrackingEvents(trackingIds);
  const eventData = useMemo(() => results.map(r => r.data).flat().filter(Boolean), [results])

  const scrollToSection = () => window.scrollTo({ top: 700, behavior: "smooth" });

  const [trackingId, setTrackingId] = useState("");

  useEffect(() => {
    if (isSuccess) {
      if (trackingData?.length) {
        setTrackingIds(trackingData.map(x => x.id));
      } else {
        setTrackingId('');
      }
    }
  }, [isSuccess, trackingData])

  useEffect(() => {
    console.log('TRIGGER')
    const correctionEvent = eventData.find(event => event.type === 'CORRECTION')

    if (correctionEvent && correctionEvent.meta.new_identification_number) {
      navigate(`/?transaksi=${correctionEvent.meta.new_identification_number}`)
    }

    if (trackingData?.length && !trackingId) {
      const lastTracking = orderBy(trackingData, ["created_at"], ["desc"]);

      setTrackingId(lastTracking[0].id)
    }


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventData, trackingData, trackingId])


  const handleSearch = (value) => {
    navigate(`/?transaksi=${value}`)
  };

  useEffect(() => {
    if (numberParam) {
      scrollToSection()
    }
  }, [numberParam])

  return (
    <>
      <Hero onSearch={handleSearch}></Hero>
      {isFetching && <LoadingSpinner />}
      {!isFetching && <>
        {trackingId || !numberParam ? <BodySearch trackingId={trackingId} /> : <DataNotFound />}
      </>}
      <Footer></Footer>
    </>
  );
}
